module.exports = __webpack_public_path__ + "rails.b19890.svg";